export default __webpack_public_path__ + "static/media/wallet.d34ad9fa.svg";